export enum PakBomViewMode {
  List = 'list',
  Optimizer = 'optimizer',
}
